const { __ } = wp.i18n;
const { InspectorControls, InnerBlocks, TextAlignmentControl } = wp.blockEditor;
const { useState, useEffect, useRef } = wp.element;
const { TextareaControl, PanelBody, __experimentalHeading, TextControl, __experimentalInputControl, __experimentalInputControlSuffixWrapper, __experimentalToggleGroupControl, __experimentalBorderBoxControl, Icon, SelectControl, __experimentalToggleGroupControlOptionIcon, __experimentalDivider, BaseControl, Flex, FlexBlock, TabPanel } = wp.components;
import { useBlockProps } from '@wordpress/block-editor';
import DimensionsControl from '../../controls/dimensions/dimensions.js';
import ShortUniqueId from 'short-unique-id';
import { textColor } from '@wordpress/icons';
import { attributes } from '../attributes.js';
import { generateCSS, getCssCustomBlock, addAttributeResponsive, getCustomAttribute, replaceBackgroundImage } from '../functions.js';
import CustomAttributeControl from '../../controls/custom-attribute/custom-attribute.js';
import ColorSelector from '../../controls/color-select/color-select.js';
import BorderControl from '../../controls/border/border.js';
import TypographyControl from '../../controls/typography/typography.js';
import BacgroundControl from '../../controls/background/background.js';
import DisplayControl from '../../controls/display/display.js';
import CssCustom from '../../controls/css-custom/css-custom.js';
import SizingControl from '../../controls/sizing/sizing.js';
import { useSelect } from '@wordpress/data';
import DynamicDropdown from '../../controls/dynamic/dropdown/dropdown.js'
import './basic-text.css';

wp.blocks.registerBlockType('softlite-io-integration/basic-text', {
    apiVersion: 3,
    title: __('Basic Text'),
    icon: textColor,
    category: 'softlite-io-integration',
    attributes: addAttributeResponsive(attributes),
    edit: (props) => {
        const { attributes, setAttributes } = props;
        const [css, setCss] = useState('');
        const generateID = new ShortUniqueId({ length: 8, dictionary: 'alphanum_lower' });
        const [textContent, setTextContent] = useState(attributes?.['basic-text']?.content ? attributes?.['basic-text']?.content : '');
        const { id, custom_attributes } = attributes;
        const [htmlTag, setHtmlTag] = useState(attributes?.['basic-text']?.tag ? attributes?.['basic-text']?.tag : 'div');
        const [TagName, setTagName] = useState(attributes?.['basic-text']?.tag ? attributes?.['basic-text']?.tag : 'div');
        const [attributeCustom, setAttributeCustom] = useState({});
        const openTab = attributes?.state?.openTab ?? 'setting';
        const openSettingSection = attributes?.state?.openSettingSection ?? 'settings';
        const openStyleSection = attributes?.state?.openStyleSection ?? 'layout';

        const currentDevice = useSelect((select) => {
            return select('core/edit-post').__experimentalGetPreviewDeviceType();
        }, []);
        const device = currentDevice.toLowerCase();
        const deviceString = device === 'desktop' ? '' : `:${device}`;

        useEffect(() => {
            if (!id) {
                setAttributes({ id: generateID.rnd() });
            }
            const newCss = generateCSS(attributes, `softlite-block-${attributes.id}`);
            let cssCustomString = getCssCustomBlock(attributes);
            setAttributes({ css: newCss });
            setCss(replaceBackgroundImage(cssCustomString + newCss, softliteData.site_url));
            setAttributeCustom(getCustomAttribute(custom_attributes));
        }, [attributes]);

        const handleToggle = (name, type) => {
            setAttributes({state: {...attributes?.state, [type]: name === attributes?.state?.[type] ? '' : name}});
        };

        const handleChangeContent = (newContent) => {
            setTextContent(newContent);
            setAttributes({
                'basic-text': {
                    ...attributes['basic-text'],
                    content: newContent,
                },
            });
            setAttributes({ heading: { content: newContent } })
        }

        const setNewHtmlTag = (newTag) => {
            setAttributes({ 'basic-text': { ...attributes?.['basic-text'], tag: newTag } });
            if (newTag == 'custom') {
                setTagName('div');
                setHtmlTag(newTag);
            } else {
                setTagName(newTag);
                setHtmlTag(newTag);
            }
        }

        const setCustomTag = (newCustomTag) => {
            setAttributes({ 'basic-text': { ...attributes?.['basic-text'], customTag: newCustomTag } });
            setTagName(newCustomTag);
        }

        const handleChangeTextContent = (shortcode, textContent) => {
            const newText = (textContent ?? "") + shortcode;
            handleChangeContent(newText);
        }

        if (TagName == 'custom') {
            setTagName(attributes?.['basic-text']?.customTag ? attributes?.['basic-text']?.customTag : 'div');
        }

        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';

        const blockProps = useBlockProps({
            className: 'softlite-block-basic-text' + (textContent === '' ? ' softlite-block-empty' : '') + advancedClassNames,
        });

        return (
            <>
                <InspectorControls>
                    <TabPanel
                        className="softlite-tab-panel"
                        activeClass="active-tab"
                        onSelect={(newTab) => setAttributes({state: {...attributes?.state, openTab: newTab}})}
                        initialTabName={openTab}
                        tabs={[
                            {
                                name: 'setting',
                                title: 'Setting',
                                className: 'softlite-tab-setting',
                            },
                            {
                                name: 'style',
                                title: 'Style',
                                className: 'softlite-tab-style',
                            },
                        ]}
                    >
                        {(tab) => <div>
                            {openTab == 'setting' && (
                                <PanelBody title={__('Settings')} opened={openSettingSection === 'settings'} onToggle={() => handleToggle('settings', 'openSettingSection')}>
                                    <div style={{position: 'relative'}} className='softlite-basic-text-dynamic'>
                                        <TextareaControl
                                            label="Content"
                                            value={textContent}
                                            onChange={(newContent) => handleChangeContent(newContent)}
                                            className="softlite-heading-content"
                                            rows="12"
                                        />
                                        <DynamicDropdown onSelect={(shortcode) => handleChangeTextContent(shortcode, textContent)} />
                                    </div>

                                    <SelectControl
                                        label="HTML Tag"
                                        value={attributes?.['basic-text']?.tag}
                                        options={[
                                            { label: 'div', value: 'div' },
                                            { label: 'p', value: 'p' },
                                            { label: 'span', value: 'span' },
                                            { label: 'figcaption', value: 'figcaption' },
                                            { label: 'address', value: 'address' },
                                            { label: 'figure', value: 'figure' },
                                            { label: 'Custom', value: 'custom' },
                                        ]}
                                        labelPosition="edge"
                                        className="softlite-heading-select"
                                        onChange={(newTag) => setNewHtmlTag(newTag)}
                                    />
                                    {htmlTag == 'custom' && (
                                        <TextControl
                                            label="Custom tag"
                                            value={attributes?.['basic-text']?.customTag}
                                            onChange={(value) => setCustomTag(value)}
                                            className="softlite-text-control"
                                        />
                                    )}
                                </PanelBody>
                            )}
                            {openTab == 'style' && (
                                <>
                                    <PanelBody title={__('Layout')} opened={openStyleSection === 'layout'} onToggle={() => handleToggle('layout', 'openStyleSection')} >
                                        <__experimentalHeading>SPACING</__experimentalHeading>
                                        <label>Padding</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="padding"
                                        />
                                        <__experimentalDivider />
                                        <label>Margin</label>
                                        <DimensionsControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                            attributeName="margin"
                                        />
                                        <__experimentalDivider />
                                        <SizingControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Typography')} opened={openStyleSection === 'typography'} onToggle={() => handleToggle('typography', 'openStyleSection')}>
                                        <TypographyControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Background')} opened={openStyleSection === 'background'} onToggle={() => handleToggle('background', 'openStyleSection')}>
                                        <BacgroundControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Border')} opened={openStyleSection === 'border'} onToggle={() => handleToggle('border', 'openStyleSection')}>
                                        <BorderControl
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Attributes')} opened={openStyleSection === 'custom-attribute'} onToggle={() => handleToggle('custom-attribute', 'openStyleSection')}>
                                        <CustomAttributeControl
                                            items={custom_attributes}
                                            onChange={(newItems) => setAttributes({ custom_attributes: newItems })}
                                        />
                                    </PanelBody>
                                    <PanelBody title={__('Custom CSS')} opened={openStyleSection === 'custom-css'} onToggle={() => handleToggle('custom-css', 'openStyleSection')}>
                                        <CssCustom
                                            attributes={attributes}
                                            setAttributes={setAttributes}
                                        />
                                    </PanelBody>
                                </>
                            )}
                        </div>}
                    </TabPanel>
                </InspectorControls>

                <TagName {...blockProps} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: textContent }} />
                {css && (
                    <style type='text/css'>{css}</style>
                )}
            </>
        );
    },
    save: (props) => {
        const { attributes } = props;
        const textContent = attributes?.['basic-text']?.content ? attributes?.['basic-text']?.content : '';
        const TagName = attributes?.['basic-text']?.tag || 'div';
        const advancedClassNames = attributes.className ? ' ' + attributes.className : '';
        const allClassNames = `softlite-block-basic-text${advancedClassNames}`;
        let attributeCustom = getCustomAttribute(attributes?.custom_attributes);

        return (
            <>
                <TagName className={allClassNames} id={`softlite-block-${attributes.id}`} {...attributeCustom} dangerouslySetInnerHTML={{ __html: textContent }} />
            </>
        )
    },
});